import UserImage from '../UserImage';

function UserPPImage({ username, imgSrc, id }) {
  return <UserImage userName={username} avatar={imgSrc} userId={id} />;
}

export default UserPPImage;
